import { render, staticRenderFns } from "./Pair_Landing.vue?vue&type=template&id=1674b354&scoped=true&"
import script from "./Pair_Landing.vue?vue&type=script&lang=js&"
export * from "./Pair_Landing.vue?vue&type=script&lang=js&"
import style0 from "./Pair_Landing.vue?vue&type=style&index=0&id=1674b354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674b354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
